import type { OrganisationTree } from 'api/organisations';
import type { FarmPickerOption } from 'components/FarmPickerField';
import type { FarmOption } from 'farmContext';
import type { AccountInfoData } from 'types';
import { findFarmHierarchy, getFarmRoleForAccount } from 'utils/organisationContext';

export const buildFarmPickerOptions = (
  farmOptions: FarmOption[],
  _organisations?: OrganisationTree[],
  _accountInfo?: AccountInfoData,
): FarmPickerOption[] =>
  farmOptions.map((farmOption) => ({
    value: farmOption.farmId,
    label: farmOption.label,
    // Users only need the farm name in the top picker — no organisation/company labels.
    searchText: farmOption.label,
  }));

export const getFarmPickerContextMeta = (
  organisations: OrganisationTree[] | undefined,
  accountInfo: AccountInfoData | undefined,
  farmId: string | number | null | undefined,
) => {
  const hierarchy = findFarmHierarchy(organisations, farmId);
  const farmRole = getFarmRoleForAccount(accountInfo, farmId);

  return {
    hierarchy,
    farmRoleName: farmRole?.roleName,
  };
};
